import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "d-flex align-start" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "cy-snackbar-wrapper" };
const _hoisted_4 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_snackbar = _resolveComponent("v-snackbar");
    return (_openBlock(), _createBlock(_component_v_snackbar, {
        modelValue: _ctx.isShow,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.isShow) = $event)),
        timeout: _ctx.timeout,
        location: "top"
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("img", {
                    class: "snackbar-icon",
                    src: _ctx.iconPath
                }, null, 8 /* PROPS */, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snackbarMessage, (message, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: key,
                            class: "cy-snackbar-item"
                        }, [
                            (_ctx.snackbarMessage.length > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " * "))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(" " + _toDisplayString(message), 1 /* TEXT */)
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createCommentVNode("\n        <span\n        v-if=\"getterIsSingleMessage\"\n      >\n        {{ snackbarMessage }}\n      </span>\n      <div\n        v-else\n        class=\"d-flex flex-column\"\n      >\n        <div\n          v-for=\"(message, key) in snackbarMessage\"\n          :key=\"key\"\n        >\n          {{ `* ${message}` }}\n        </div>\n      </div>\n      ")
            ])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "timeout"]));
}
